import React, { ForwardedRef, forwardRef, memo, useMemo } from 'react';
import { RegistrationFieldProps } from './RegistrationField.types';
import customComponents from './FieldComponents';
import DefaultField from './FieldComponents/DefaultField/DefaultField';
import { Box, Text, TextInput } from '@betty/moonlight';

function RegistrationField(
  props: RegistrationFieldProps,
  ref: ForwardedRef<TextInput>,
) {
  const FieldComponent = useMemo(
    () =>
      (props.name
        ? customComponents[props.name as keyof typeof customComponents]
        : null) ?? DefaultField,
    [props.name],
  );
  const hideGenericError = props.hideGenericError ?? false;
  const displayableError =
    typeof props.error === 'string' && !hideGenericError ? props.error : null;

  return (
    <Box>
      <FieldComponent ref={ref} {...props} />
      {displayableError ? (
        <Text color="darkSurfaceError" variant="body-m" marginTop="space-200">
          {displayableError}
        </Text>
      ) : null}
      {!displayableError && props.footerNS && props.footerKey ? (
        <Text
          variant="body-s"
          color="darkSurfaceSecondary"
          locNS={props.footerNS}
          locKey={props.footerKey}
          marginTop="space-200"
        ></Text>
      ) : null}
    </Box>
  );
}

export default memo(forwardRef(RegistrationField));
